module.exports = __webpack_public_path__ + "img/gate_1_1.1f5d2072.png";